import React from 'react';
import PropTypes from 'prop-types';
import PreviewCompatibleImage from '../components/PreviewCompatibleImage';
import { Util } from '../lib/util';

const ResourceGrid = ({ gridItems }) => (
  <div className="columns is-multiline">
    {gridItems.map(item => {
      const click = () => {
        if (item.link) {
          Util.openURL(item.link);
        }
      };
      return (
        <div key={item.text} className="column is-4">
          <div className="has-text-centered is-clickable" onClick={click}>
            <div
              style={{
                width: '60%',
                display: 'inline-block',
                position: 'relative',
                minHeight: '220px',
                margin: '0',
              }}
            >
              <PreviewCompatibleImage imageInfo={item} />
            </div>
          </div>
          <div
            className="has-text-centered is-clickable is-size-4"
            onClick={click}
          >
            <a href={item.link} target="_blank" rel="noreferrer noopener">
              {item.title}
            </a>
          </div>
          <p>{item.text}</p>
        </div>
      );
    })}
  </div>
);

ResourceGrid.propTypes = {
  gridItems: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
      text: PropTypes.string,
    })
  ),
};

export default ResourceGrid;
